/**
 * Gallery Help System — distinct injectable system for the Gallery interface.
 * Content tree: assets/help/gallery/<locale>/...
 */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { HelpSystemBase } from '../help-system-base';
import { HelpSystemId, RouteHelpMapping } from '../help.types';
import { galleryRouteHelpMap } from './gallery-route-map';

@Injectable({ providedIn: 'root' })
export class GalleryHelpService extends HelpSystemBase {
  readonly systemId: HelpSystemId = 'gallery';
  protected readonly routeMap: RouteHelpMapping[] = galleryRouteHelpMap;

  constructor(router: Router) {
    super(router);
  }
}
